import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 针对ElementUI导航栏中重复导航报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        //关于我们
        {
          path: '/aboutus',
          name: 'aboutus',
          component: resolve => require(['@/view/AboutUs'], resolve),
          meta: {
            title: '关于我们'
          },
          children: [
            {
              path: '/aboutus/companyintroduce',
              name: 'companyintroduce',
              component: resolve => require(['@/view/AboutUS_companyIntroduce'], resolve),
              meta: {
                title: '公司介绍'
              }
              // redirect: '/aboutus/companyintroduce'
            },
            {
              path: '/aboutus/companyculture',
              name: 'companyculture',
              component: resolve => require(['@/view/AboutUS_companyCulture'], resolve),
              meta: {
                title: '公司文化'
              }
            },
            {
              path: '/aboutus/qualificationhonor',
              name: 'qualificationhonor',
              component: resolve => require(['@/view/AboutUS_qualificationHonor'], resolve),
              meta: {
                title: '资质荣誉'
              }
            },
            {
              path: '/aboutus/develophistory',
              name: 'develophistory',
              component: resolve => require(['@/view/AboutUS_developHistory'], resolve),
              meta: {
                title: '发展历程'
              }
            },
            {
              path: '/aboutus/partners',
              name: 'partners',
              component: resolve => require(['@/view/AboutUS_partners'], resolve),
              meta: {
                title: '合作伙伴'
              }
            },
            {
              path: '/aboutus/contactus',
              name: 'contact',
              component: resolve => require(['@/view/AboutUS_contactUS'], resolve),
              meta: {
                title: '联系我们'
              }
            },
            {
              path: '/contactusdetail',
              name:'contactusdetail',
              meta:{
                title:'更多合作伙伴',
              },
              component: resolve => require(['@/view/AboutUS_detail'], resolve),
            },
          ]
        },
        //公司
        {
          path: '/company',
          name: 'company',
          component: resolve => require(['@/view/Company'], resolve),
          meta: {
            title: '公司动态'
          },
          children: [
            {
              path: '/company/news',
              name: 'news',
              component: resolve => require(['@/view/Company_news'], resolve),
              meta: {
                title: '公司动态'
              },
            },
            {
              path: '/company/notice',
              name: 'companynotice',
              component: resolve => require(['@/view/Company_notice'], resolve),
              meta: {
                title: '公告通知'
              }
            },
            {
              path: '/company/partybuilding',
              name: 'companypartybuilding',
              component: resolve => require(['@/view/Company_partybuilding'], resolve),
              meta: {
                title: '党建动态'
              }
            }
          ]
        },
        //公司详细
        {
          path: '/detail',
          name:'detail',
          meta:{
            title:'动态详情',
          },
          component: resolve => require(['@/view/Business_detail'], resolve),
        },
        //服务
        {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '服务中心'
          },
          children: [             
          {
            name: "salary",
            path: "/service/salary",
            component: resolve => require(['@/view/Service_salary'], resolve),
          },
          {
            name: "socialsecurity",
            path: "/service/socialsecurity",
            component: resolve => require(['@/view/Service_socialsecurity'], resolve),
          },
          {
            name: "medicalinsurance",
            path: "/service/medicalinsurance",
            component: resolve => require(['@/view/Service_medicalinsurance'], resolve),
          },
          {
            name: "housingfund",
            path: "/service/housingfund",
            component: resolve => require(['@/view/Service_housingfund'], resolve),
          },
          {
            name: "home",
            path: "home",
            component: resolve => require(['@/view/HomePage'], resolve),
          },
          {
            name: "certificate",
            path: "/service/certificate",
            component: resolve => require(['@/view/Service_certificate'], resolve),
          },
          {
            name: "workguide",
            path: "/service/workguide",
            component: resolve => require(['@/view/Service_workguide'], resolve),
          },
          {
            name: "filedownload",
            path: "/service/filedownload",
            component: resolve => require(['@/view/File_Download'], resolve),
          },
          {
            name: "appointment",
            path: "/service/appointment",
            component: resolve => require(['@/view/Service_appointment'], resolve),
          },
          {
            name: "complaintsuggestions",
            path: "/service/complaintsuggestions",
            component: resolve => require(['@/view/Service_complaintsuggestions'], resolve),
          },
          {
            name: "searchalldata",
            path: "/service/searchalldata",
            component: resolve => require(['@/view/Search_All_Data'], resolve),
          },]
        },
        //核心业务
        {
          name: "核心业务",
          path: "/corebusiness",
          component: resolve => require(['@/view/CoreBusiness'], resolve),
          children:[
            {
              name: "hrdispatch",
              path: "/corebusiness/hrdispatch",
              meta:{
                title:'人力资源派遣',
              },
              component: resolve => require(['@/view/CoreBusiness_HRDispatch'], resolve),
            },
            {
              name: "hroutsourcing",
              path: "/corebusiness/hroutsourcing",
              meta:{
                title:'人力资源外包',
              },
              component: resolve => require(['@/view/CoreBusiness_HROutsourcing'], resolve),
            },
            {
              name: "crewcooperation",
              path: "/corebusiness/crewcooperation",
              meta:{
                title:'船员业务',
              },
              component: resolve => require(['@/view/CoreBusiness_crewTraining'], resolve),
            },
            {
              name: "skillTraining",
              path: "/corebusiness/skilltraining",
              meta:{
                title:'培训学校',
              },
              component: resolve => require(['@/view/CoreBusiness_skillTraining'], resolve),
            },
            {
              name: "overseasemployment",
              path: "/corebusiness/overseasemployment",
              meta:{
                title:'境外就业',
              },
              component: resolve => require(['@/view/CoreBusiness_oversea'], resolve),
            },
            {
              name: "recruitmentservices",
              path: "/corebusiness/recruitmentservices",
              meta:{
                title:'招聘服务',
              },
              component: resolve => require(['@/view/CoreBusiness_recruit'], resolve),
            }
          ]
        },
        //业务详细
        {
          path: '/businessdetail',
          name:'businessdetail',
          meta:{
            title:'动态详情',
          },
          component: resolve => require(['@/view/Company_detail'], resolve),
        },
         //招聘详细
        {
          path: '/recruitdetail',
          name:'recruitdetail',
          meta:{
            title:'动态详情',
          },
          component: resolve => require(['@/view/Recruit_detail'], resolve),
        },
        //办事指南详情
        {
          path: '/guidedetail',
          name:'guidedetail',
          meta:{
            title:'动态详情',
          },
          component: resolve => require(['@/view/Guide_detail'], resolve),
        },
        //搜索详情
        {
          path: '/searchdetail',
          name:'searchdetail',
          meta:{
            title:'动态详情',
          },
          component: resolve => require(['@/view/Search_detail'], resolve),
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js